/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whatwedo_Label2Inputs */

const ja_careers_whatwedo_label2 = /** @type {(inputs: Careers_Whatwedo_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WHAT WE DO`)
};

const en_careers_whatwedo_label2 = /** @type {(inputs: Careers_Whatwedo_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WHAT WE DO`)
};

/**
* | output |
* | --- |
* | "WHAT WE DO" |
*
* @param {Careers_Whatwedo_Label2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whatwedo_label2 = /** @type {((inputs?: Careers_Whatwedo_Label2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whatwedo_Label2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whatwedo_label2(inputs)
	return en_careers_whatwedo_label2(inputs)
});
export { careers_whatwedo_label2 as "careers_whatWeDo_label" }